import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MiniGameModal } from './mini-game-modal/MiniGameModal';
import { MiniGamesGrid } from './mini-games-grid/MiniGamesGrid';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { useCommon } from 'src/domains/common/Common';

export const MiniGames = observer('MiniGames', (): JSX.Element | null => {
    const common = useCommon();
    const appCasinoState = AppCasinoState.get(common);
    const { miniGamesListState } = appCasinoState;
    const { isMiniGamesListEmpty } = miniGamesListState;

    if (isMiniGamesListEmpty) {
        return null;
    }

    const { miniGameModel, regularGameModel } = appCasinoState.gameModalState;
    const isGameOpened = miniGameModel !== null || regularGameModel !== null;

    return (
        <>
            {miniGameModel === null ? null : (
                <MiniGameModal
                    appCasinoState={appCasinoState}
                    gameDataState={miniGameModel}
                />
            )}
            <MiniGamesGrid
                appCasinoState={appCasinoState}
                isGameOpened={isGameOpened}
            />
        </>
    );
});
